<template>
    <component :is="current" to="destination">
        <div class="print-only" v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewDashboard)" id="dashboard-main">
            <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
            <template v-else>
                <div class="row" >
                    <div class="col-12 mb-4 d-flex" style="justify-content: space-between; align-items: center; flex-wrap: wrap; gap:10px">
                        <div class="d-flex" style="align-items: center; gap:10px; flex-wrap: wrap;">
                            <el-select multiple v-model="filter" placeholder="Status" @change="loadAllWidget">
                                <el-option value="all" label="All"/>
                                <el-option value="confirmed">Confirmed</el-option>
                                <el-option value="pending">Pending</el-option>
                                <el-option value="rejected">Rejected</el-option>
                                <el-option value="deleted">Deleted</el-option>
                            </el-select>
                            <el-select 
                                multiple 
                                v-model="paymentStatus" 
                                placeholder="Status"
                                @change="getData"
                                class=""
                            >
                                <el-option value="all" label="All">All</el-option>
                                <el-option value="full-payment" label="Fully Paid">Fully Paid</el-option>
                                <el-option value="no-payment" label="Not Paid">Not Paid</el-option>
                                <el-option value="partial-payment" label="Partial Payment">Partial Payment</el-option>
                            </el-select>
                            <div class="d-flex align-items-center justify-content-between" style="gap:30px; ">
                                <div class="d-flex align-items-center">
                                    <el-tooltip class="mr-2" content="Show all Widgets" placement="top">
                                        <el-switch
                                            v-model="allWidgetsShown"
                                            @change="loadAllWidget"
                                            style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
                                        />
                                    </el-tooltip>
                                    Show all Widgets
                                </div>
                                <el-button @click="exportDivToPdf('.print-only')" :loading="loadingDownload" class="btn m-0">
                                    <fa icon="download"/>
                                </el-button>
                            </div>
                        </div>
                        <div class="no-print">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <card class="card-stats" style="min-height: 255px;">
                            <div class="statistics statistics-horizontal mb-2" style="border-bottom: 1px solid #E5E5E5;">
                                <div class="info info-horizontal">
                                    <h2>Registration Info</h2>
                                    <div class="d-flex" style="justify-content: center;">
                                        <fa :icon="['fas', 'users']" size="3x"/>
                                    </div>
                                    <div class="d-flex p-0 m-0" style="flex-wrap: wrap; justify-content: center;">
                                        <div class="left" style="text-align: center;">
                                            <h3 class="info-title">{{ getTotalRegistrationCount }}</h3>
                                            <p class="stats-title">Registrations</p>
                                        </div>
                                        <div class="right" style="text-align: center;">
                                            <h3 class="info-title">{{ getTotalAttendees.length }}</h3>
                                            <p class="stats-title">Registrants</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="stats">
                                <fa :icon="['far', 'arrow-alt-circle-up']"/> {{ getTotalAttendees.length - getRegCheckinCount }} remaining<br>
                                <fa :icon="['fas', 'plus']"/> {{ getRegCheckinCount }} Checked In
                            </div>
                        </card>
                    </div>
                    <div :class="this.event.enableUnsatisfiedMinimumCount ? 'col-md-3':'col-md-9'" class="col-md-3" v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].viewTransactionSummary))">
        
                        <card class="card-stats" style="min-height: 255px;">
                            <div class="statistics statistics-horizontal">
                                <div class="info info-horizontal">
                                    <h2>Transaction Summary</h2>
                                    <div class="d-flex" style="justify-content: center;">
                                        <fa :icon="['fas', 'ticket-alt']" size="3x"/>
                                    </div>
        
                                    <div class="d-flex mt-2" style="text-align: center; justify-content: center; align-items: center; gap:10px">
                                        <h3 class="info-title p-0 m-0">$ {{ getTotals }} </h3>
                                        <p class="stats-title m-0 p-0" style="font-size: 16px; height: auto;">Total</p>
                                    </div>
        
                                    <div class="d-flex p-0 m-0" style="flex-wrap: wrap; justify-content: center; gap:20px">
                                        <div class="left" style="text-align: center;">
                                            <h3 class="info-title">$ {{ getPaids }}</h3>
                                            <p class="stats-title">Collected</p>
                                        </div>
                                        <div class="right" style="text-align: center;">
                                            <h3 class="info-title">$ {{ getDues }}</h3>
                                            <p class="stats-title">Due</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </card>
                        
                    </div>
                    
                    <div class="col-md-6" v-if="this.event.enableUnsatisfiedMinimumCount">
                        <stats-card
                            style="min-height: 255px;"
                            type="warning"
                            header="Unsatisfied Minimum Count"
                            :title="getUnsatisfiedMinimumCount">
                        </stats-card>
                    </div>
    
                </div>
                <div class="row widgets-row">
                    <div style="display: flex; justify-content: center;"  v-if="allWidgetsShown && getWidgets.length" v-for="(widget, index) in getWidgets" :key="`custom-widget-${widget._id}`"
                        :class="getColClass(index, getWidgets.length)"
                    >
                        <stats-card
                            style="min-height: 255px; display: flex; justify-content: center;"
                            type="warning"
                            :header="widget.title"
                            :title="widget.title">
                            <!-- <div class="d-flex p-0 m-0" style="flex-wrap: wrap; justify-content: center;">
                                <div style="text-align: center; width: 50%;">
                                    <h3 class="info-title">{{ getTotalRegistrationCount }}</h3>
                                    <p class="stats-title">Registrations</p>
                                </div>
                                <div style="text-align: center; width: 50%;">
                                    <h3 class="info-title">{{ getTotalAttendees.length }}</h3>
                                    <p class="stats-title">Registrants</p>
                                </div>
                            </div> -->
    
                            <div class="d-flex p-0 m-0 " style="flex-wrap: wrap; justify-content: center; gap:15px;">
                                <div v-if="widget.combinedCount" style="text-align: center; ">
                                    <h3 class="info-title">{{ widget.count.total || 0 }}</h3>
                                    <p class="stats-title">TOTAL</p>
                                </div>
                                <template v-else>
                                    <div v-for="(value, index) in widget.values" style="text-align: center; ">
                                        <h3 class="info-title">{{ widget.count[value] || 0  }}</h3>
                                        <p class="stats-title">
                                            <span v-if="widget.showValueInsteadOfLabel"> {{ value }} </span> 
                                            <span v-else> {{ widget.labels[index] }} </span>
                                        </p>
                                    </div>
                                </template>
                            </div>
    
    
    
    
    
    
    
    
    
                            <!-- <div class="d-flex" style="gap:10px; color: black; font-size: 15.4px;" v-if="widget.combinedCount">
                                <span style="font-weight: bold;">TOTAL : </span>{{ widget.count.total || 0}}
                            </div>
                            <div v-else>
                                <p v-for="(value, index) in widget.values" class="d-flex p-0" style="gap:10px; color: black;">    
                                    <span style="font-weight: bold;">
                                        <span v-if="widget.showValueInsteadOfLabel"> {{ value }} </span> 
                                        <span v-else> {{ widget.labels[index] }} </span>
                                        :
                                    </span>
                                    {{ widget.count[value] || 0 }}
                                </p>
                            </div> -->
                        </stats-card>
                    </div>
                </div>
                <div class="row">
                    <div
                        v-for="(activity, index) in stats.activities"
                        :key="`activity-stat-${activity._id}`"
                        :class="getColClass(index, stats.activities.length)"
                    >
                        <stats-card
                            style="min-height: 255px;"
                            type="danger"
                            :title="`${getAttendees[activity._id] ? getAttendees[activity._id].length : 0}`"
                            :header="activity.name"
                            subTitle="Total"
                        >
                                <template slot="icon">
                                    <fa :icon="['fas', 'barcode']" size="3x"/>
                                </template>
                                <div slot="footer">
                                    <fa :icon="['far', 'arrow-alt-circle-up']"/> {{ getAttendees[activity._id] && getCheckinedInAttendees[activity._id] ? getAttendees[activity._id].length - checkedInForActivity(activity._id) : 0 }} Remaining<br>
                                    <fa :icon="['fas', 'plus']"/> {{ checkedInForActivity(activity._id) }} Checked In
                                </div>
                        </stats-card>
                    </div>
                </div>
            </template>
        </div>
    </component>
</template>

<script>
import StatsCard from '@/components/now-ui/Cards/StatsCard'
import { mapState } from 'vuex'
import http from '../http.js'
import download from 'downloadjs'
import html2canvas from 'html2canvas'
import { jsPDF } from "jspdf";

export default {
    components: {
        StatsCard
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ]),
        getTotals(){
            let totals = 0
            Object.keys(this.stats.transactions.totals).forEach(key =>{
                if(this.filter.includes('all')){
                    totals = this.stats.transactions.totals['all']
                }
                else if(this.filter.includes(key)){
                    totals += this.stats.transactions.totals[key]
                }
            })
            return String(totals)
        },
        getPaids(){
            let paids = 0
            Object.keys(this.stats.transactions.paids).forEach(key =>{
                if(this.filter.includes('all')){
                    paids = this.stats.transactions.paids['all']
                }
                else if(this.filter.includes(key)){
                    paids += this.stats.transactions.paids[key]
                }
            })
            return String(paids);
        },
        getDues(){
            let dues = 0
            Object.keys(this.stats.transactions.dues).forEach(key =>{
                if(this.filter.includes('all')){
                    dues = this.stats.transactions.dues['all']
                }
                else if(this.filter.includes(key)){
                    dues += this.stats.transactions.dues[key]
                }
            })
            return String(dues);
        },
        getUnsatisfiedMinimumCount(){
            let count = 0;
            Object.keys(this.stats.unsatisfiedMinimumCountWithStatus).forEach(key =>{
                if(this.filter.includes('all')){
                    count += parseInt(this.stats.unsatisfiedMinimumCountWithStatus[key])
                }
                else if(this.filter.includes(key)){
                    count += parseInt(this.stats.unsatisfiedMinimumCountWithStatus[key])
                }
            })
            return String(count);
        },
        getAttendees() {
            let obj = {}
            this.stats.activities.forEach(activity => {
                obj[activity._id] = []
                activity.registeredAttendees.forEach(attendee => {
                    if(this.filter.includes('all')) {
                        if(this.paymentStatus.includes('all')) obj[activity._id].push(attendee);
                        else if(this.paymentStatus.includes('partial-payment') && attendee.paid > 0 && !attendee.fullyPaid) obj[activity._id].push(attendee);
                        else if(this.paymentStatus.includes('no-payment') && attendee.paid == 0 ) obj[activity._id].push(attendee);
                        else if(this.paymentStatus.includes('full-payment') && attendee.fullyPaid) obj[activity._id].push(attendee);
                    }
                    else if(this.filter.includes(attendee.status)){
                        // obj[activity._id].push(attendee)
                        if(this.paymentStatus.includes('all')) obj[activity._id].push(attendee);
                        else if(this.paymentStatus.includes('partial-payment') && attendee.paid > 0 && !attendee.fullyPaid) obj[activity._id].push(attendee);
                        else if(this.paymentStatus.includes('no-payment') && attendee.paid == 0 ) obj[activity._id].push(attendee);
                        else if(this.paymentStatus.includes('full-payment') && attendee.fullyPaid) obj[activity._id].push(attendee);
                    }

                })
            })
            return obj
        },
        getCheckinedInAttendees() {
            let obj = {}
            this.stats.activities.forEach(activity => {
                obj[activity._id] = []
                activity.checkedInAttendees.forEach(attendee => {
                    if(this.filter.includes('all')) {
                        obj[activity._id].push(attendee)
                    }
                    else if(this.filter.includes(attendee.status)){
                        obj[activity._id].push(attendee)
                    }  
                })
            })
            return obj
        },
        getTotalAttendees() {
            const users = this.stats.users.total.filter(user => {
                if(this.filter.includes('all')) return true;
                return this.filter.includes(user.status);
            })
            return users;
        },
        getRegCheckinCount(){
            const users = this.stats.users.checkedIn.filter(checkin => {
                if(checkin.type !== 'registration') return false;
                if(this.filter.includes('all')) return true;
                return this.filter.includes(checkin.registration.status);
            })
            return users.length;
        },
        getCheckinCountForActivities(){
            const users = this.stats.users.checkedIn.filter(checkin => {
                if(checkin.type !== 'activity') return false;
                if(this.filter.includes('all')) return true;
                return this.filter.includes(checkin.registration.status);
            })
            return users.length;
        },
        getTotalRegistrationCount(){
            let confirmationNumbers = new Set([])
            this.getTotalAttendees.forEach(attendee => {
                confirmationNumbers.add(attendee.confirmationNumber)
            })
            return confirmationNumbers.size
        },
        getWidgets(){
            return Object.values(this.widgets);
        }
    },
    data () {
        return {
            current: "div",
            loading: true,
            loadingDownload: false,
            loadingWidgets: false,
            allWidgetsShown: false,
            paymentStatus: ["all"],
            filter: ["confirmed","pending"],
            stats: {
                users: {
                    checkedIn: [],
                    total:[]
                },
                sales: {
                    paid: 0,
                    pending: 0
                },
                activities: []
            },
            widgets: []
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        async exportDivToPdf(selector = ".print-only", opts = {}) {
            this.loadingDownload = true
            // options with defaults
            const widthMM = opts.widthMM || 210; // physical width in mm (A4 width = 210mm)
            const pageFormat = opts.pageFormat || "a4"; // or provide custom
            const imageQuality = typeof opts.quality === "number" ? opts.quality : 0.92;
            const scale = opts.scale || 2; // 2 or 3 for higher DPI

            // find the source element
            const src = document.querySelector(selector);
            if (!src) {
            console.error("exportDivToPdf: selector not found:", selector);
            return;
            }

            // Create offscreen container and clone the node
            const off = document.createElement("div");
            off.style.position = "fixed";
            off.style.left = "-9999px";
            off.style.top = "0";
            off.style.width = widthMM + "mm"; // fixed physical width
            off.style.boxSizing = "border-box";
            off.style.background = "#ebecf1"; // ensure background
            // ensure printed fonts/styles apply: clone stylesheet links & style tags if needed
            // Simple approach: clone computed styles via copying <link> and <style> nodes:
            // (You can also rely on global CSS present in page; copying links is safer for CDNs)
            const headClone = document.createElement("div");
            // Clone links
            Array.from(document.querySelectorAll('link[rel="stylesheet"]')).forEach(l => {
            try {
                const cl = l.cloneNode(true);
                cl.onload = () => {};
                off.appendChild(cl); // appending link inside off is ok; browser loads it
            } catch(e) {}
            });
            // Clone inline styles
            Array.from(document.querySelectorAll("style")).forEach(s => {
            if ((s.textContent || "").trim().length) {
                const cl = document.createElement("style");
                cl.type = "text/css";
                cl.textContent = s.textContent;
                off.appendChild(cl);
            }
            });

            // Append offscreen container to body
            document.body.appendChild(off);

            // Clone the actual element (deep clone)
            const cloned = src.cloneNode(true);

            // Optional: remove elements with .no-print in the clone
            const toRemove = cloned.querySelectorAll(".no-print");
            if (toRemove && toRemove.length) {
            toRemove.forEach(n => n.remove());
            }

            off.appendChild(cloned);

            // Wait a tick so styles load / render (simple wait)
            await new Promise(resolve => setTimeout(resolve, 250));

            // Determine pixel width of the off element (needed for html2canvas)
            // computed style width in px:
            const offRect = off.getBoundingClientRect();
            const pxWidth = Math.round(offRect.width);

            // Use html2canvas to render
            const canvas = await html2canvas(cloned, {
                scale: scale,
                useCORS: true,
                allowTaint: false,
                backgroundColor: "#ebecf1",
                width: pxWidth,
                // If your cloned content is taller than viewport, allow the full height:
                scrollY: -window.scrollY
            });

            // Convert canvas to image data
            const imgData = canvas.toDataURL("image/jpeg", imageQuality);

            // jsPDF expects dimensions in mm (we used widthMM)
            // const { jsPDF } = window.jspdf; // when using UMD build
            // compute height in mm using canvas pixel ratio
            const canvasWidthPx = canvas.width;
            const canvasHeightPx = canvas.height;
            const mmPerPx = widthMM / canvasWidthPx; // mm per pixel for the chosen width
            const imgHeightMM = canvasHeightPx * mmPerPx;


            // Define margins in mm
            const marginLeft = 10;
            const marginTop = 10;
            const usableWidth = widthMM - marginLeft * 2;
            const usableHeight = imgHeightMM - marginTop * 2;

            // Keep aspect ratio
            let drawWidth = usableWidth;
            let drawHeight = (canvasHeightPx * (usableWidth / canvasWidthPx));

            if (drawHeight > usableHeight) {
                // If height overflows, fit by height instead
                drawHeight = usableHeight;
                drawWidth = (canvasWidthPx * (usableHeight / canvasHeightPx));
            }

            // Center horizontally/vertically within margins
            const x = marginLeft + (usableWidth - drawWidth) / 2;
            const y = marginTop + (usableHeight - drawHeight) / 2;



            // Create pdf with width = widthMM, height = imgHeightMM (or fit to a4)
            // For single page output sized to content:
            const pdf = new jsPDF({
                orientation: imgHeightMM > widthMM ? "portrait" : "landscape",
                unit: "mm",
                format: [widthMM, imgHeightMM]
            });

            // Parse computed rgb/rgba into jsPDF fillColor
            pdf.setFillColor('#ebecf1');
            pdf.rect(0, 0, widthMM, imgHeightMM, "F");

            // Add image at 0,0 sized widthMM x imgHeightMM
            pdf.addImage(imgData, "JPEG", x, y, drawWidth, drawHeight, undefined, "FAST");

            // Save
            pdf.save(opts.filename || "export.pdf");

            // Cleanup
            off.remove();
            this.loadingDownload = false
        },
        async printRoot() {
            if(this.current == "portal"){

                window.print();
                this.current = "div"
                this.$store.commit('SET_PROPS', ['isMobile', window.innerWidth < 768])
            }else{
                this.current = "portal"
                this.$store.commit('SET_PROPS', ['isMobile', false])
            }
        },

        async downloadAsReport(){
            this.loadingDownload = true
            try {

                const fields = [
                    "Name",
                    "Registrations",
                    "Registrants",
                    "Total",
                    "Collected",
                    "Due",
                    "Unsatisfied Minimum Count",
                    "Activity Name",
                    "Total",
                    "Checked In",
                    "Remaining",
                    "Widget Name",
                    "Widget Data"
                ]

                const values = [
                    [   "Registration Info", 
                        this.getTotalRegistrationCount, 
                        this.getTotalAttendees.length,
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ],
                    [   "Transaction Summary", 
                        "", 
                        "", 
                        this.getTotals, 
                        this.getPaids, 
                        this.getDues, 
                        this.getUnsatisfiedMinimumCount,
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ],
                ]
                
                this.stats.activities.forEach(activity => {
                    values.push(
                        [
                            "Activity Summary",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            activity.name,
                            this.getAttendees[activity._id] ? this.getAttendees[activity._id].length : 0,
                            this.checkedInForActivity(activity._id),
                            this.getAttendees[activity._id] && this.getCheckinedInAttendees[activity._id] ? this.getAttendees[activity._id].length - this.checkedInForActivity(activity._id) : 0,
                            "",
                            "",
                        ]
                    )
                });

                if(this.allWidgetsShown){

                    this.getWidgets.forEach(widget => {
                        values.push([
                            "Custom Widget",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            widget.title,
                            JSON.stringify(widget.count)    
                        ])
                    })
                }


                const response = await http.post('/api/registrations/download-from-screen', { fields, data:values }, {
                    responseType: 'arraybuffer'
                })
                download(response.data, 'attendees.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting dashboard data')
            }
            this.loadingDownload = false
            
        },
        getColClass(index, total) {
            // figure out which group of 4 this item belongs to
            const groupStart = Math.floor(index / 4) * 4;
            const left = total - groupStart; // how many items remain in this group

            if (left >= 4) {
                return "col-md-3"; // full row of 4
            }
            if (left === 3) {
                return "col-md-4"; // 3 equal cols
            }
            if (left === 2) {
                return "col-md-6"; // 2 equal cols
            }
            if (left === 1) {
                return "col-md-12"; // single col full width
            }
        },
        async loadAllWidget(){
            this.loadingWidgets = true
            try {
                const res = await http.get('/api/custom-widgets/calculated', {
                    params: {
                        eventId: this.$route.params.eventId,
                        paymentStatus: this.paymentStatus,
                        status: this.filter,
                    }
                });
                this.widgets = res.data.widgets
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
            this.loadingWidgets = false    

        },
        getData: async function () {
            this.loading = true
            try {
                const response = await http.get(`/api/stats/${this.$route.params.eventId}?${this.event.enableUnsatisfiedMinimumCount ? 'unsatisfiedMinimumCount=true' : ''}`, { 
                    params: { paymentStatus: this.paymentStatus } 
                })
                this.stats = response.data.stats                

                if(this.allWidgetsShown){
                    await this.loadAllWidget()
                }
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting dashboard data')
            }
            this.loading = false
        },
        checkedInForActivity(actId){
            let count = 0;
            this.stats.users.checkedIn.forEach(checkin => {
                if(checkin.activity == actId) count++
            })
            return count
        }
    }
}
</script>

<style lang="sass">
#dashboard-main
    .card-stats .statistics .stats-title
        height: 32px

.widgets-row 
    .col-7 
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;

.print-root 
    background: #ebecf1;
    width: 1200px;
</style>
